export enum CargoTempCategory {
    Inhibited = 1,
    HeatSensitive = 2,
    HeatedCooled = 3,
    NonHeat = 4,
}

export interface CargoInTankItem {
    cargoNumber: string;
    isOnBoard: boolean;
    tankId: number;
    tradeName: string;
    cargoTempCategory: CargoTempCategory;
}
